import { getAuthMethod, postAuthMethod } from "./HttpServices";

const API_BASE = "api/mail-merge/jobs";

export const getMailMergeCampaigns = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const endpoint = query ? `${API_BASE}?${query}` : API_BASE;
    const response = await getAuthMethod(endpoint);
    return response.data;
  } catch (error) {
    console.error("Error fetching mail merge campaigns:", error);
    throw error;
  }
};

export const getMailMergeStats = async () => {
  try {
    const response = await getAuthMethod(`${API_BASE}/stats`);
    return response.data;
  } catch (error) {
    console.error("Error fetching mail merge stats:", error);
    throw error;
  }
};

export const getMailMergeCampaignById = async (id) => {
  try {
    const response = await getAuthMethod(`${API_BASE}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching mail merge campaign ${id}:`, error);
    throw error;
  }
};

export const createMailMergeCampaign = async (payload) => {
  try {
    const response = await postAuthMethod(API_BASE, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating mail merge campaign:", error);
    throw error;
  }
};

export const startMailMergeCampaign = async (id) => {
  try {
    const response = await postAuthMethod(`${API_BASE}/${id}/start`);
    return response.data;
  } catch (error) {
    console.error(`Error starting mail merge campaign ${id}:`, error);
    throw error;
  }
};

export const pauseMailMergeCampaign = async (id) => {
  try {
    const response = await postAuthMethod(`${API_BASE}/${id}/pause`);
    return response.data;
  } catch (error) {
    console.error(`Error pausing mail merge campaign ${id}:`, error);
    throw error;
  }
};

export const cancelMailMergeCampaign = async (id) => {
  try {
    const response = await postAuthMethod(`${API_BASE}/${id}/cancel`);
    return response.data;
  } catch (error) {
    console.error(`Error cancelling mail merge campaign ${id}:`, error);
    throw error;
  }
};

export const retryFailedMailMergeCampaign = async (id) => {
  try {
    const response = await postAuthMethod(`${API_BASE}/${id}/retry-failed`);
    return response.data;
  } catch (error) {
    console.error(`Error retrying failed mail merge campaign ${id}:`, error);
    throw error;
  }
};
